import { Button, Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { delProgram } from '../../api'
import '../../pages/index.css'
import { deleteprogram } from '../../slice/trainingslice'
import { DelProgramIprops } from '../type'

const DelFolder = ({ show, onClose, data }: DelProgramIprops) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Training Program"
            body={
                <>
                    <p className="del-desc">
                        Are you sure you want to delete this Training Program ?
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                try {
                                    // Call the asynchronous function and wait for its result
                                    const response = await delProgram(data.id)
                                    if (response) {
                                        dispatch(
                                            SHOW_NOTIFICATION({
                                                type: 'success',
                                                message:
                                                    'Program deleted successfully',
                                            })
                                        )
                                    }

                                    // Dispatch the action with the data if needed

                                    dispatch(deleteprogram(data.id))

                                    // You can also use the data received from the API if needed
                                } catch (err) {
                                    // Handle any errors here
                                    console.error(
                                        'Error fetching holidays:',
                                        err
                                    )
                                }

                                onClose(false)
                            }}
                        >
                            YES
                        </Button>
                        <Button
                            type="submit"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelFolder
